const accessPaymentHistory = {
    PAYMENT_HISTORY_LIST: { name: 'Payment History', path: '/payment-history-list' },
    PAYMENT_HISTORY_DETAILS: { name: 'Payment History Details', path: '/payment-history-details' },
}

export default accessPaymentHistory;
